export const SHARED_ALBUM_CLAIM_CONTEXT_KEY = 'everbook.sharedAlbumContributionClaim.v1';

export function storeSharedAlbumClaimContext(context) {
  try {
    sessionStorage.setItem(SHARED_ALBUM_CLAIM_CONTEXT_KEY, JSON.stringify(context));
  } catch {
    // Claim continuation is optional; upload remains complete.
  }
}

export function readSharedAlbumClaimContext() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(SHARED_ALBUM_CLAIM_CONTEXT_KEY) || 'null');
    return parsed?.claim_token ? parsed : null;
  } catch {
    return null;
  }
}

export function clearSharedAlbumClaimContext() {
  try {
    sessionStorage.removeItem(SHARED_ALBUM_CLAIM_CONTEXT_KEY);
  } catch {}
}

export function safeSharedAlbumClaimAnalyticsContext(context = {}) {
  return {
    contribution_batch_id: context.contribution_batch_id || null,
    album_title: context.album_title || null,
    share_slug: context.share_slug || null,
    auth_flow: context.auth_flow || null,
  };
}

export function trackSharedAlbumConversionEvent(event, context = {}) {
  const safeContext = safeSharedAlbumClaimAnalyticsContext(context);
  try {
    window?.posthog?.capture?.(event, safeContext);
  } catch {
    // Analytics must never block contribution claiming.
  }
}
